<template>
    <div>

        <PageHeader>
            {{ $t('invoices') }}
            <template #side>
                <ButtonIcon hide-label-while-loading :to="{ name: 'SettlementsInvoicesCreate' }">
                    {{ $t('add') }}
                </ButtonIcon>
            </template>
        </PageHeader>

        <Filters ref="Filters" />

        <Results ref="Results" />

    </div>
</template>



<script>
    import { format as dateFormat, addDays } from 'date-fns';
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';

    const DATE_FORMAT = 'yyyy-MM-dd';
    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        advertisers: [],
        campaigns: [],
        statuses: [],
        startDate: dateFormat(addDays(Date.now(), -30), DATE_FORMAT),
        endDate: dateFormat(Date.now(), DATE_FORMAT),
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({});

    export default {
        name: 'AdvertiserSettlementsList',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('advertiserSettlements/Invoices'),
            };
        },
    };
</script>
